// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2lBgv","empty":"ModalGraph_empty__RRv7A"};